import { ToasterProps } from '@/components/shared/snackbar-popup';
import { createStore, stateSetterHandler } from '@alpha.apps/react-common';

export type snackState = {
  snack: ToasterProps;
};

const initState: snackState = {
  snack: {
    isOpen: false,
    message: '',
    type: 'success',
    icon: '',
    id: '',
  },
};

export const useSnack = createStore({
  name: 'snack',
  devtools: true,
  persist: false,
})(initState, set => {
  const handler = stateSetterHandler(set);
  return {
    setSnack: handler('snack'),
  };
});
